import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ConfigService } from '@klickdata/core/config';
import { YouTubeVideoData } from '@klickdata/core/resource/src/resource.service';
import { Utils } from '@klickdata/core/util';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '@klickdata/core/auth';
import { TagService } from '@klickdata/core/resource/src/tag/tag.service';
import moment from 'moment';
import {
    combineLatest,
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
    Observable,
    of,
    startWith,
    switchMap,
    takeUntil,
} from 'rxjs';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { LanguageService } from '@klickdata/core/localization';
@Component({
    selector: 'app-youtube-link-info-player',
    templateUrl: './youtube-link-info-player.component.html',
    styleUrls: ['./youtube-link-info-player.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YoutubeLinkInfoPlayerComponent extends OnDestroyHandler implements OnChanges, OnInit {
    @Input() placeholder: string = 'Enter YouTube URL';
    @Input() urlSource: FormControl = new FormControl(null);
    @Input() disabled: boolean = false;
    @Input() showInput: boolean = true;
    @Input() showYoutubeMetadata: boolean = true;
    Utils = Utils;
    public youTubeVideoInfo$: Observable<YouTubeVideoData | null>;
    public isLoadingVideoInfo: boolean = false;
    public onSnippetRetrieved: EventEmitter<{ title: string; tag_ids: number[]; description: string }> =
        new EventEmitter<{ title: string; tag_ids: number[]; description: string }>();
    public currentLaguageId$: Observable<number>;
    constructor(
        protected config: ConfigService,
        protected http: HttpClient,
        protected authService: AuthService,
        protected tagsService: TagService,
        protected langService: LanguageService
    ) {
        super();
    }
    ngOnInit(): void {
        this.currentLaguageId$ = this.langService
            .getLanguageByKey(this.langService.getCurrentLanguage().value)
            .pipe(map((lang) => lang.id));
    }
    goToLink(url: string) {
        if (Utils.isUrl(url)) {
            window.open(url, '_blank');
        }
    }
    get mediaKey() {
        const link = this.urlSource.value;
        if (link && Utils.isVideoUrl(link)) {
            return link;
        }
    }
    ngOnChanges(changes: SimpleChanges): void {
        console.log('urlSource', this.urlSource.value);
        this.urlSource.valueChanges
            .pipe(takeUntil(this.destroy), debounceTime(300), distinctUntilChanged(), startWith(this.urlSource.value))
            .subscribe((value) => {
                console.log('value', value);
                if (value) {
                    // this.getLinkInfo(value);
                }
            });
    }
    private getLinkInfo(link: string) {
        if (Utils.isYoutubeURL(link)) {
            this.isLoadingVideoInfo = true;
            const apiUrl = `https://www.googleapis.com/youtube/v3/videos?id=${Utils.getYoutubeMedia(link).src}&key=${
                this.config.config.YOUTUBE_DATA_API_KEY
            }&part=snippet,contentDetails`;
            this.youTubeVideoInfo$ = this.http.get<any>(apiUrl).pipe(
                map((res) => {
                    if (res?.items?.length) {
                        return res.items[0];
                    } else {
                        this.isLoadingVideoInfo = false;
                        return null;
                    }
                }),
                filter((res) => !!res),
                switchMap((item) => combineLatest([of(item), this.authService.getCustomer()])),
                switchMap(([item, customer]) =>
                    combineLatest([
                        of(item),
                        item.snippet?.tags && !!item.snippet?.tags?.length
                            ? this.currentLaguageId$.pipe(
                                  switchMap((languageId) =>
                                      this.tagsService
                                          .createManyTags(item.snippet?.tags, languageId, customer.id)
                                          .pipe(map((tags) => tags.map((tag) => tag.id)))
                                  )
                              )
                            : of([]),
                    ])
                ),
                map(([item, tagIds]) => {
                    this.isLoadingVideoInfo = false;
                    this.onSnippetRetrieved.emit({
                        title: item.snippet.title,
                        tag_ids: tagIds,
                        description: item.snippet?.description,
                    });
                    return {
                        title: item.snippet.title,
                        duration: moment.duration(item.contentDetails.duration).asSeconds().toString(),
                    };
                })
            );
        } else {
            this.youTubeVideoInfo$ = of(null);
        }
    }
}
